import { ChainId } from '@pancakeswap/chains'

export const verifyMantleNetwork = (chainId?: number) => {
  return Boolean(chainId && chainId === ChainId.TAIKO)
}

export const verifyTaikoHeklaNetwork = (chainId?: number) => {
  return Boolean(chainId && chainId === ChainId.TAIKO)
}
